module.exports = "<div class=\"modal-body modal-body--widget-creation modal-body--center\"> <loading-spinner></loading-spinner> </div> ";